"use client"

import { useState } from "react"

const ColoringBeads = ({ onScore }) => {
  const [currentTask, setCurrentTask] = useState(0)
  const [coloredBeads, setColoredBeads] = useState([])

  const tasks = [
    { animals: ["🐢", "🐢", "🐢", "🐢", "🐢"], count: 5, name: "черепахи" },
    { animals: ["🐻", "🐻"], count: 2, name: "медведи" },
    { animals: ["🎈", "🎈", "🎈", "🎈", "🎈", "🎈", "🎈", "🎈", "🎈", "🎈"], count: 10, name: "шарики" },
    { animals: ["🍇", "🍇", "🍇", "🍇", "🍇", "🍇", "🍇", "🍇"], count: 8, name: "сливы" },
    { animals: ["🐥", "🐥", "🐥", "🐥"], count: 4, name: "цыплята" },
  ]

  const current = tasks[currentTask]

  const colorBead = (index) => {
    if (coloredBeads.includes(index)) {
      setColoredBeads(coloredBeads.filter((i) => i !== index))
    } else if (coloredBeads.length < current.count) {
      setColoredBeads([...coloredBeads, index])
      if (coloredBeads.length + 1 === current.count) {
        onScore(20)
        setTimeout(() => {
          setCurrentTask((prev) => (prev + 1) % tasks.length)
          setColoredBeads([])
        }, 2000)
      }
    }
  }

  return (
    <div className="lesson-card card-teal">
      <h2 className="lesson-title" style={{ color: "#0f766e" }}>
        Раскрашиваем бусинки 🎯
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "24px",
          marginBottom: "24px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Считаем {current.name}</h3>
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "8px" }}>
              {current.animals.map((animal, index) => (
                <div key={index} style={{ fontSize: "1.875rem" }}>
                  {animal}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Абакус</h3>
          <div
            style={{
              backgroundColor: "white",
              padding: "16px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "4px" }}>
              {Array.from({ length: 10 }, (_, index) => (
                <button
                  key={index}
                  onClick={() => colorBead(index)}
                  style={{
                    width: "32px",
                    height: "24px",
                    borderRadius: "50%",
                    border: "2px solid",
                    backgroundColor: coloredBeads.includes(index) ? "#8b5cf6" : "#e5e7eb",
                    borderColor: coloredBeads.includes(index) ? "#7c3aed" : "#9ca3af",
                    cursor: "pointer",
                    margin: "0 auto",
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ fontSize: "1.125rem", marginTop: "8px" }}>
            Раскрашено: {coloredBeads.length}/{current.count}
          </div>
        </div>
      </div>

      {coloredBeads.length === current.count && (
        <div
          style={{
            textAlign: "center",
            fontSize: "1.25rem",
            color: "#16a34a",
            fontWeight: "bold",
          }}
        >
          🎉 Отлично! Число {current.count} записано правильно! 🎉
        </div>
      )}
    </div>
  )
}

export default ColoringBeads
